import request from '@/utils/httpRequest'
//  获取品牌活动列表
export function getBrandactivityList (query) {
  return request({
    url: '/api/activity/web/brandActivity/page',
    method: 'get',
    params: query
  })
}

//  品牌活动详情

export function getBrandactivityDetail (id) {
  return request({
    url: '/api/activity/web/brandActivity/' + id,
    method: 'get'
  })
}

//  获取关联资讯

export function getBrandactivityInfo (query) {
  return request({
    url: '/api/information/web/page',
    method: 'get',
    params: query
  })
}

//  获取关联活动

export function getBrandactivityActs (query) {
  return request({
    url: '/api/activity/web/page',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/brandactivity/index.js